import { createContext, useState, useEffect } from 'react';

export const TableFiltersContext = createContext();

const initialTableFiltersState = {
    cheatDefinitions: {
        currentFilters: null,
    },
};

export const TableFiltersContextProvider = ({ children }) => {
	const [tableFiltersState, setTableFiltersState] = useState(initialTableFiltersState);

    const resetTableFiltersState = () => {
        setTableFiltersState(initialTableFiltersState);
    }

	return (
		<TableFiltersContext.Provider value={{ tableFiltersState, setTableFiltersState, resetTableFiltersState }}>
			{children}
		</TableFiltersContext.Provider>
	);
};
